import React, { useEffect } from "react";
import { Form, Input, Modal, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getStates } from "../../store/actions/state";
import { getCountries } from "../../store/actions/country";

const CityForm = ({ visible, onCreate, onCancel, record }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const StateList = useSelector((state) => state.state.list);
  const countryList = useSelector((state) => state.country.list);


  const handleChange = (value) => {
    console.log(`selected ${value}`);
  };

  useEffect(() => {
    if (visible) {
      dispatch(getCountries())
      dispatch(getStates());
    }
  }, [visible, dispatch]);

  useEffect(() => {
    if (record) {
      form.setFieldsValue(record);
      // form.setFieldsValue({
      //   name: record.name,
      //   coId: record.coId,
      //   stId: record.stId,
      // });
    } else {
      form.resetFields();
    }
  }, [record, form]);

  return (
    <Modal
      visible={visible}
      // title={record ? "Update City" : "Add City"}
      title={"Add City"}
      okText="Submit"
      cancelText="Cancel"
      // onCancel={onCancel}
      onCancel={() => {
        form.resetFields(); // Reset form fields when modal is closed
        onCancel(); // Call the onCancel handler
      }}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            onCreate(values);
            form.resetFields();
          })
          .catch((info) => {
            console.log("Validate Failed:", info);
          });
      }}
      width={800}
    >
      <Form
        form={form}
        layout="vertical"
        name="model_form"
        initialValues={record}
      >
        <Form.Item
          name="coId"
          label="Country"
          rules={[{ required: true, message: 'Please select a country!' }]}
        >
          <Select placeholder="Select a country" showSearch onChange={handleChange}
          filterOption={(input, option) =>
            option.children.toLowerCase().includes(input.toLowerCase())
          }
          >
            {countryList.map((country) => (
              <Select.Option key={country.id} value={country.id}>
                {country.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="stId"
          label="State"
          rules={[{ required: true, message: "Please select a state!" }]}
        >
          <Select placeholder="Select a state"  onChange={handleChange}
            showSearch
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
          >
            {StateList.map((state) => (
              <Select.Option key={state.id} value={state.id}>
                {state.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="name"
          label="Name"
          rules={[{ required: true, message: "Please enter the city name!" }]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CityForm;
